import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Params } from '@angular/router';
import { SortOption } from '@models/api-search.models';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sorting',
    templateUrl: './sorting.component.html',
    styleUrls: ['./sorting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgFor, SvgIconComponent]
})
export class SortingComponent implements OnChanges {
    public sort: SortOption;

    @Input()
    public readonly sortOptions?: SortOption[];

    @Output()
    public readonly sortOptionUpdate = new EventEmitter<Params>();

    ngOnChanges(): void {
        this.sort = this.sortOptions?.find(option => option.selected) || {};
    }

    public onModelUpdate(option: SortOption): void {
        this.sortOptionUpdate.emit({ sort: option.key });
    }
}
